<div class="cpcontent">
    <h2>Draw a Circle on a Map</h2>
    <button class="btn btn-primary" (click)="initMap()">Init Map</button>
    <span *ngIf="showFilter" style="margin-left:20px">
        Radius: <input [(ngModel)]="radius" />
        Click on map to define the circle. Then you can click on any spot and find the distance to the circle
    </span>
    <div #pagemap style="width:100%;height:400px"></div>
</div>